import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/kokan/reporte-aprobados";

// 🔥 Servicio con parámetros dinámicos
export const obtenerAprobados = async (params = {}) => {
    try {
        const response = await axios.post(`${baseUrl}${endpoint}`, params);


        if (response.status === 200) {
            return {
                ok: true,
                data: response.data.data, // 🔥 AQUÍ EL FIX
                total: response.data.total,
            };
        }

        return {
            ok: false,
            message: "Error en la respuesta del servidor",
        };

    } catch (error) {
        console.error("Error consultando aprobados:", error);

        return {
            ok: false,
            message: error.response?.data?.message || "Error de conexión",
        };
    }
};